import {StyleteqState} from "../_definitions/styleteq";
import {createSelector} from "reselect/src";
import Feed from "../_data/models/Feed";
import {Map} from "immutable";
import {dataByResourceNameSelector} from "../_data/selectors";

export const loadingFeedsSelector = (state: StyleteqState) => state.feeds.loading;
export const feedsSelector = (state: StyleteqState) => state.feeds.items;
export const feedSelector = (state: StyleteqState, id: number) => createSelector(
    feedsSelector,
    (feeds: Map<number, Feed>) => feeds.get(id)
)(state);

export const feedModelSelector = (state: StyleteqState, feed: Feed) => {
    return dataByResourceNameSelector(state, feed.resource).get(feed.trackableId);
}

export const feedsMetaSelector = (state: StyleteqState) => state.feeds.meta;

export const feedsCommentsSelector = (state: StyleteqState) => state.feeds.comments;


// WEBPACK FOOTER //
// ./app/client/activityFeeds/selectors.ts